export default {
  LOAD_EMPLOYEE_LIST(state, data) {
    state.employeeList = data.data;
  },
};
